import { createContext, useContext, useState, useEffect } from "react"
import { useNavigate } from 'react-router-dom'
import { jwtDecode } from 'jwt-decode'
import Axios from "axios"
import Swal from 'sweetalert2'
import i18n from 'i18next'
const t = i18n.t.bind(i18n)

export const AuthContext = createContext()

const useLogoutClient = () => {
    return async () => {
        localStorage.removeItem("jwt")
    }
}

const useLoginClient = (setClientauth) => {
    const navigate = useNavigate()

    return async (userCredentials) => {
        const options = {
            headers: { "Access-Control-Allow-Origin": "*" },
        }

        try {
            const result = await Axios.post(
                process.env.REACT_APP_DB_ADDRESS + "/api/login/in",
                { email: userCredentials.email, password: userCredentials.password, app: 'rumiantec' },
                options
            )

            const token = result.data["token"]
            
            if (token && token !== "undefined") {
                localStorage.setItem("jwt", token)
                // Decodificamos el token para obtener los datos del usuario
                const decoded = jwtDecode(token)
                let rol = decoded.rol

                // Actualiza el estado de clientauth en el AuthProvider
                setClientauth(decoded)

                // Redirigir según el rol
                if (rol === 'admin') {
                    return navigate(`/${t("url.admin.admin")}/${t("url.admin.dashboard")}`)
                } else {
                    if (rol === 'technical') {
                        return navigate(`/${t("url.technical.technical")}/${t("url.admin.dashboard")}`)
                    } else if (rol === 'breeder') {
                        return navigate(`/${t("url.breeder.breeder")}/${t("url.admin.dashboard")}`)
                    } else {
                        if (window.location.pathname !== '/') {
                            return navigate('/')
                        }
                    }
                }
            } else {
                // Si el token no es válido, mostrar mensaje de error
                Swal.fire({
                    showConfirmButton: true,
                    confirmButtonColor: '#3085d6',
                    buttonsStyling: false,
                    confirmButtonText: 'Cerrar',
                    icon: 'error',
                    text: result.data.message,
                })
            }
        } catch (error) {
            console.error("Error al iniciar sesión:", error)
            Swal.fire({
                showConfirmButton: true,
                confirmButtonColor: '#3085d6',
                buttonsStyling: false,
                confirmButtonText: 'Cerrar',
                icon: 'error',
                text: 'Ocurrió un error al intentar iniciar sesión',
            })
        }
    }
}

export function AuthProvider({ children }) {
    const [clientauth, setClientauth] = useState(null)
    const loginClient = useLoginClient(setClientauth)
    const logoutClient = useLogoutClient()
    const storedToken = localStorage.getItem("jwt")

    useEffect(() => {
        try {
            setClientauth(storedToken ? jwtDecode(storedToken) : null)
        } catch (error) {
            setClientauth(null)
            localStorage.removeItem("jwt")
        }
    }, [storedToken])

    const contextValue = { clientauth, loginClient, logoutClient, setClientauth }

    return (
        <AuthContext.Provider value={contextValue}>
            {children}
        </AuthContext.Provider>
    )
}

export function useAuth() {
    const context = useContext(AuthContext)
    return context
}